(function () {
  function twoLineHeight(el) {
    var cs = window.getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);
    if (!lh || cs.lineHeight === 'normal') {
      lh = parseFloat(cs.fontSize) * 1.45;
    }
    return Math.round(lh * 2);
  }

  function initBar(root) {
    var desc = root.querySelector('[data-lifestyle-description]');
    var toggle = root.querySelector('[data-lifestyle-toggle]');
    if (!desc || !toggle) return;

    var labelMore = toggle.getAttribute('data-label-more') || 'Read more';
    var labelLess = toggle.getAttribute('data-label-less') || 'Show less';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!desc.id) {
      desc.id = 'collection-lifestyle-desc-' + Math.random().toString(36).slice(2, 9);
    }
    toggle.setAttribute('aria-controls', desc.id);
    toggle.setAttribute('aria-expanded', 'false');

    function contentOverflows() {
      desc.classList.remove('is-clamped');
      desc.style.maxHeight = 'none';
      var full = desc.scrollHeight;
      var needs = full > twoLineHeight(desc) + 1;
      desc.style.maxHeight = '';
      if (needs) desc.classList.add('is-clamped');
      return needs;
    }

    function syncToggle() {
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      var needs = contentOverflows();
      toggle.hidden = !needs;
      if (!needs) desc.classList.remove('is-clamped');
    }

    function lockHeroMedia() {
      var media = root.querySelector('.collection-lifestyle-bar__media');
      var content = root.querySelector('.collection-lifestyle-bar__content');
      if (!media || !content) return;
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      if (!desktop) {
        root.style.removeProperty('--lifestyle-hero-media-height');
        return;
      }
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      root.style.setProperty('--lifestyle-hero-media-height', content.offsetHeight + 'px');
    }

    syncToggle();
    lockHeroMedia();

    function flashToggleLabel(nextLabel) {
      toggle.classList.add('is-updating');
      toggle.textContent = nextLabel;
      window.setTimeout(function () {
        toggle.classList.remove('is-updating');
      }, reducedMotion ? 0 : 200);
    }

    function finishCollapsed() {
      desc.classList.add('is-clamped');
      desc.classList.remove('is-collapsing');
      desc.style.maxHeight = '';
    }

    function setExpanded(expand) {
      var collapsed = twoLineHeight(desc);

      if (reducedMotion) {
        if (expand) {
          desc.classList.remove('is-clamped', 'is-collapsing');
          desc.style.maxHeight = 'none';
          toggle.setAttribute('aria-expanded', 'true');
          flashToggleLabel(labelLess);
        } else {
          finishCollapsed();
          toggle.setAttribute('aria-expanded', 'false');
          flashToggleLabel(labelMore);
        }
        return;
      }

      if (expand) {
        desc.classList.remove('is-clamped', 'is-collapsing');
        desc.style.maxHeight = 'none';
        var fullHeight = desc.scrollHeight;
        desc.classList.add('is-height-animated');
        desc.style.maxHeight = collapsed + 'px';
        desc.offsetHeight;
        requestAnimationFrame(function () {
          desc.style.maxHeight = fullHeight + 'px';
        });
        toggle.setAttribute('aria-expanded', 'true');
        flashToggleLabel(labelLess);

        var onExpandEnd = function (e) {
          if (e.propertyName !== 'max-height') return;
          desc.removeEventListener('transitionend', onExpandEnd);
          if (toggle.getAttribute('aria-expanded') === 'true') {
            desc.style.maxHeight = 'none';
          }
        };
        desc.addEventListener('transitionend', onExpandEnd);
        window.setTimeout(function () {
          desc.removeEventListener('transitionend', onExpandEnd);
          if (toggle.getAttribute('aria-expanded') === 'true') desc.style.maxHeight = 'none';
        }, 450);
      } else {
        var currentHeight = desc.scrollHeight;
        desc.classList.add('is-height-animated', 'is-collapsing');
        desc.style.maxHeight = currentHeight + 'px';
        desc.offsetHeight;
        requestAnimationFrame(function () {
          desc.style.maxHeight = collapsed + 'px';
        });
        toggle.setAttribute('aria-expanded', 'false');
        flashToggleLabel(labelMore);

        var onCollapseEnd = function (e) {
          if (e.propertyName !== 'max-height') return;
          desc.removeEventListener('transitionend', onCollapseEnd);
          if (toggle.getAttribute('aria-expanded') === 'false') finishCollapsed();
        };
        desc.addEventListener('transitionend', onCollapseEnd);
        window.setTimeout(function () {
          if (toggle.getAttribute('aria-expanded') === 'false') finishCollapsed();
        }, 450);
      }
    }

    toggle.addEventListener('click', function () {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        syncToggle();
        lockHeroMedia();
      }, 150);
    });
  }

  function initScrollButtons() {
    document.querySelectorAll('[data-scroll-to-collection-grid]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('collection-product-grid');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });

      /* Native <button> :hover can fail to paint custom backgrounds in some
         browsers; mirror hover with a class so the Luxus white state shows. */
      btn.addEventListener('pointerenter', function () {
        btn.classList.add('is-hovered');
      });
      btn.addEventListener('pointerleave', function () {
        btn.classList.remove('is-hovered');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-collection-lifestyle-bar]').forEach(initBar);
    initScrollButtons();
  });
})();
